import type { Appearance } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useEffect, useState } from "react";

import { useStripePublishableKey } from "@/queries/organization-queries";
import { getCSSValue } from "@/utils/css";

export const getStripeAppearance = (): Appearance => {
    const appearance = {
        variables: {
            colorBackground: `rgb(${getCSSValue("--surface-primary")})`,
            colorText: `rgb(${getCSSValue("--content-primary")})`,
            colorPrimary: `rgb(${getCSSValue("--content-primary")})`,
            colorPrimaryText: `rgb(${getCSSValue("--content-secondary")})`,
        },
    };
    return appearance;
};

export const useStripePromise = () => {
    const [stripePromise, setStripePromise] = useState<ReturnType<typeof loadStripe> | undefined>();
    const { data: stripeKey, isLoading } = useStripePublishableKey();

    useEffect(() => {
        if (stripeKey && !stripePromise) {
            setStripePromise(loadStripe(stripeKey));
        }
    }, [stripeKey, stripePromise]);

    return {
        stripePromise,
        isLoading,
    };
};
